<template>
  <div>
    <div class="e-card" style="margin-top: 5px">
      <div
        class="e-card-content"
        style="display: grid; grid-template-columns: repeat(4, 1fr); column-gap: 5%"
      >
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="applicationTypesDS"
          placeholder="Application Type"
          :fields="productFields"
          v-model="productCode"
        />
        <ejs-datepicker
          float-label-type="Always"
          v-model="startDate"
          placeholder="Date From"
          format="dd/MM/yyyy"
        />
        <ejs-datepicker
          float-label-type="Always"
          v-model="endDate"
          placeholder="Date To"
          format="dd/MM/yyyy"
        />
        <div style="width: 2%; padding-top: 4%">
          <ejs-button
            type="button"
            cssClass="e-danger"
            v-on:click.native="onOkButtonClick"
            :disabled="isButtonDisabled"
          >
            Search
          </ejs-button>
        </div>
      </div>
    </div>
    <div style="margin-top: 5px">
      <ejs-grid
        ref="grid"
        :dataSource="reports"
        :allowSorting="true"
        :allowPaging="true"
        :allowTextWrap="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        :created="created"
        :toolbarClick="toolbarClick"
        :allowExcelExport="true"
        :excelQueryCellInfo="excelQueryCellInfo"
        height="100%"
        width="100%"
      >
        <e-columns>
          <e-column field="requestor"
          headerText="Applicant Name"
          textAlign="Left"
          width="170" />
          <e-column
            field="billingAddress"
            headerText="Applicant Address"
            textAlign="Left"
            width="250"
          />
          <e-column
            field="municipality"
            headerText="Municipality"
            textAlign="Left"
            width="150"
          />
          <e-column
            field="requestUserEmail"
            headerText="Applicant Email"
            textAlign="Left"
            width="200"
          />
          <e-column
            field="productName"
            headerText="Application Type"
            textAlign="Left"
            width="200"
          />
          <e-column
            field="stage"
            headerText="Email Stage"
            textAlign="Left"
            width="200"
          />
          <e-column
            field="sendDate"
            headerText="Date Sent"
            textAlign="Left"
            type="date"
            :format="gridDateFormat"
            width="200"
          />
          <e-column
            field="sendTo"
            headerText="Email Sent To"
            textAlign="Left"
            width="220"
          />
          <e-column
            field="ccTo"
            headerText="Email CC To"
            textAlign="Left"
            width="200"
          />
          <e-column
            field="status"
            headerText="Status"
            textAlign="Left"
            width="120"
          />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';

import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { mapGetters } from 'vuex';
import { reportExportFileName } from '@/utils/report-utils';
import { applicationTypes } from '../services/usercredits-api';
import { getAutoEmailReports } from '../services/reports-api';

import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils';

Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(GridPlugin);

export default {
  name: 'AutoEmail',
  data() {
    return {
      productCode: null,
      startDate: null,
      endDate: null,
      applicationTypesDS: null,
      dates: ['Invoice date', 'Transaction date'],
      reports: null,
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: { pageSize: 15 },
      productFields: { text: 'ProductName', value: 'ProductCode' },
      gridDateFormat: getDataGridDateFormat(),
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
    }),
    isButtonDisabled() {
      return !this.productCode;
    },
  },
  async created() {
    const resp = await applicationTypes();
    const regTypeItems = [];
    regTypeItems.push({ ProductCode: 'STSOP||STSOPPATCH', ProductName: 'STS Annual Operating Permit' });
    regTypeItems.push({ ProductCode: 'STSOPTEMP', ProductName: 'STS Operating Permit' });

    const nonRegTypeItems = resp.data.filter((sx) => sx.productType !== 'Registration').map((item) => ({
      ProductCode: item.productCode,
      ProductName: item.productName,
    }));
    this.applicationTypesDS = regTypeItems.concat(nonRegTypeItems);
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.grid) {
        document
          .getElementById(`${this.$refs.grid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.grid.$el.id);
          });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async onOkButtonClick() {
      const reportData = [];
      const sDate = this.startDate ? this.startDate.toISOString() : '';
      const eDate = this.endDate ? this.endDate.toISOString() : '';
      const queryCodes = this.productCode.split('||');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < queryCodes.length; i++) {
        // eslint-disable-next-line no-await-in-loop
        const resp = await getAutoEmailReports(queryCodes[i], sDate, eDate);
        reportData.push(...resp.data);
      }
      this.reports = reportData;
    },
    excelQueryCellInfo(args) {
      // eslint-disable-next-line default-case
      switch (args.column.field) {
        case 'sendDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.grid.excelExport({
            fileName: reportExportFileName('Auto Emails.xlsx'),
          });
          break;
      }
    },
  },
};
</script>
